<template lang="html">
  <el-dialog
    title="常用路线"
    v-if="dialogVisible"
    :visible="dialogVisible"
    :append-to-body="true"
    @close="close"
    width="900px"
    class="common-routes-dialog"
  >
    <el-table
      :data="tableData"
      border
      header-row-class-name="common-routes-header"
      cell-class-name="common-routes-cell"
      v-loading="loading"
    >
      <el-table-column fixed prop="date" label="请选择" width="70">
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isChecked"
            @change="checkedChnage(scope.$index)"
            class="table-checkbox"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        prop="startContactName"
        align="center"
        label="发货联系人"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="startContactPhone"
        align="center"
        label="发货联系电话"
        width="180"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="startPoint"
        align="center"
        label="发货点省市区"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.startPointCity + scope.row.startPointDistrict
          }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="startPoint"
        align="center"
        label="发货点联系地址"
        show-overflow-tooltip
        width="180"
      >
        <template slot-scope="scope">
          <span
            class="link-url"
            @click="
              showDetail({
                name: scope.row.startPoint,
                location: scope.row.startPointLocation
              })
            "
            >{{ scope.row.startPoint }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="endContactName"
        align="center"
        label="到货联系人"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="endContactPhone"
        align="center"
        label="到货联系电话"
        width="180"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="date"
        align="center"
        label="到货点省市区"
        width="180"
      >
      </el-table-column> -->
      <el-table-column
        prop="endPoint"
        align="center"
        label="到货点联系地址"
        show-overflow-tooltip
        width="180"
      >
        <template slot-scope="scope">
          <span
            class="link-url"
            @click="
              showDetail({
                name: scope.row.endPoint,
                location: scope.row.endPointLocation
              })
            "
            >{{ scope.row.endPoint }}</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :hide-on-single-page="true"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
    <see-address-dialog
      :dialogVisible.sync="showMap"
      :addressObj="addressObj"
    />
  </el-dialog>
</template>

<script>
import seeAddressDialog from "@/views/personal/deliver/components/handlingWrapper/components/seeAddressDialog";
import qs from "qs";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: true,
      tableData: [],
      showMap: false,
      addressObj: {},
      page: 1,
      total: 0,
      loading: false
    };
  },
  computed: {},
  created() {},
  methods: {
    currentChange(val) {
      this.page = val;
      this.getList();
    },
    checkedChnage(currentIndex) {
      this.tableData.map((item, index) => {
        if (index !== currentIndex) {
          item.isChecked = false;
        }
      });
    },
    submit() {
      let obj = this.tableData.find(item => item.isChecked);
      if (!obj) {
        return this.$message.error("请先选择一条常用路线");
      }
      this.$message.success("路线选择成功");
      this.close();
      this.$emit("success", obj);
    },
    close() {
      this.$emit("update:dialogVisible", false);
    },
    async getList() {
      this.loading = true;
      let {
        data: { list, total, count }
      } = await this.$http.post(
        "/shipper/order-shipper/often-list",
        qs.stringify({
          page: this.page
        })
      );
      list.map(item => (item.isChecked = false));
      this.tableData = list;
      this.total = count;
      await this.$nextTick();
      this.loading = false;
    },
    initData() {
      this.page = 1;
      this.total = 0;
      this.getList();
    },
    showDetail(obj) {
      this.addressObj = obj;
      this.showMap = true;
    }
  },
  watch: {
    dialogVisible(newVal) {
      newVal && this.initData();
    }
  },
  components: {
    seeAddressDialog
  }
};
</script>

<style lang="scss">
.common-routes-dialog {
  .common-routes-header {
    th {
      background-color: #f5f7fa !important;
    }
  }
  tbody {
    .common-routes-cell {
      padding: 8px 0;
    }
  }
  .table-checkbox {
    margin-left: 16px;
  }
  .pagination-wrap {
    display: flex;
    flex-direction: row-reverse;
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/components/commonRoutesDialog/index.vue